import keyMirror from 'keymirror';
import { createAction } from 'redux-actions';

export const types = keyMirror({
  FILTERS_LIST_API_HOC_RESET: null,
});

export const resetFiltersListApiHOC = createAction(types.FILTERS_LIST_API_HOC_RESET);



// WEBPACK FOOTER //
// ./src/components/apiHOCs/FiltersListApiHOC/actions.js